import type { DraftContext } from '@/features/coach-review/composerDrafts';
import type { ResourceMediaSelection, ResourcePin, ResourceRecordingDescriptor } from '@/lib/types';

/** Full selected recording identity belongs to every seek, URL and strip key. */
export type ResourceVideoSource = {
  scope: DraftContext;
  recording: ResourceRecordingDescriptor;
  pin: ResourcePin|null;
};
export function resourceVideoSelection(source:ResourceVideoSource):ResourceMediaSelection {
  return source.pin?{grant:'coach',resourceId:source.pin.resource_id,revisionId:source.pin.revision_id}
    :{grant:'recording',recordingId:source.recording.recording_id,recordingGeneration:source.recording.recording_generation,
      matchId:source.recording.match_id,slot:source.recording.slot};
}
export function resourceVideoSourceKey(source:ResourceVideoSource|null):string {
  return source?JSON.stringify([source.scope.actorId,source.scope.clubId,source.scope.teamId,source.scope.seasonId,source.scope.generation,
    source.recording.recording_id,source.recording.recording_generation,source.recording.match_id,source.recording.slot,
    source.pin?.resource_id??null,source.pin?.revision_id??null]):'';
}
